import React, { Component, PropTypes } from 'react';
import bundle from './../casino/bundles.js';


class Bundle extends Component {

	componentWillMount() {
		bundle.open(this.props.match.params.bundle);
	}

	componentWillUnmount() {
		bundle.closePage();

	}

	render() {
		return (
			<div id="bundle" />
		);
	}
}

Bundle.propTypes = {
	params: PropTypes.object
};

export default Bundle;



// WEBPACK FOOTER //
// ./mobile-core/src/components/bundle.js